@if (productData && hasValidTranslations) {
<section class="section-6 mt-4 pt-4 mb-6 mb-lg-7">
    @for (overviewKeys of groupedContent['SECTION-6']; track overviewKeys;) {
    @if (overviewKeys.headingText || overviewKeys.descriptionText) {
    <div class="container text-center mb-4">
        <div class="row justify-content-center">
            <div class="col-12 col-xl-10">
                @if (overviewKeys.headingText) {
                <h2
                    [innerHTML]="overviewKeys.headingText"
                    class="text-blue-300"
                ></h2>
                } @if (overviewKeys.descriptionText) {
                <div [innerHTML]="overviewKeys.descriptionText"></div>
                }
            </div>
        </div>
    </div>
    } } @if (groupedContent['SECTION-6_IMAGE-GALLERY_IMAGE'].length > 0) {
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-lg-10">
                <div class="container-fluid">
                    <div class="row">
                        @for (imageGallery of
                        groupedContent['SECTION-6_IMAGE-GALLERY_IMAGE']; track
                        imageGallery; let i = $index; let odd = $odd) { @if
                        (imageGallery.url || imageGallery.altText) {
                        <div [ngClass]="getColumnClass(i)" class="col-12 mb-3">
                            <img
                                [alt]="imageGallery.altText"
                                [src]="imageGallery.url"
                                class="rounded-4 img-fluid h-100 w-100"
                            />
                        </div>
                        } }
                    </div>
                </div>
            </div>
        </div>
    </div>
    } @for (sideBySideKeys of groupedContent['SECTION-6_SIDE-BY-SIDE']; track
    sideBySideKeys; let i = $index; let odd = $odd) { @if (
    sideBySideKeys.buttonText || sideBySideKeys.buttonUrl ||
    sideBySideKeys.descriptionText || sideBySideKeys.headingText ||
    sideBySideKeys.imageUrl || sideBySideKeys.imageAltText ||
    sideBySideKeys.linkText || sideBySideKeys.linkUrl || sideBySideKeys.videoId
    ) {
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-lg-10">
                <vision2-side-by-side
                    [buttonText]="sideBySideKeys.buttonText"
                    [buttonUrl]="sideBySideKeys.buttonUrl"
                    [description]="sideBySideKeys.descriptionText"
                    [image]="sideBySideKeys.imageUrl"
                    [imageAlt]="sideBySideKeys.imageAltText"
                    [linkUrl]="sideBySideKeys.linkUrl"
                    [linkText]="sideBySideKeys.linkText"
                    [modalVideoId]="sideBySideKeys.videoId"
                    [heading]="sideBySideKeys.headingText"
                    [centered]="true"
                    [colorClass]="'text-bg-white'"
                    [contentColor]="'bg-transparent'"
                    [containerType]="'container-fluid'"
                    [headingValue]="2"
                    [type]="'right'"
                    [contentClass]="
                        odd
                            ? 'col-lg-6 pe-lg-1 pe-xl-2 pt-2 pt-md-4 pt-lg-0'
                            : 'col-lg-6 ps-lg-1 ps-xl-2 pt-2 pt-md-4 pt-lg-0'
                    "
                    [contentPadding]="
                        'pt-4 pt-lg-4 pt-xl-6 pb-4 pb-lg-4 pb-xl-6 px-0 text-bg-gray-20 rounded-4'
                    "
                    [imageClass]="
                        odd
                            ? 'col-lg-6 pe-lg-1 pe-xl-2'
                            : 'col-lg-6 ps-lg-1 ps-xl-2'
                    "
                    [type]="odd ? 'left' : 'right'"
                    contentPadding="'featured-product-padding'"
                    verticalPadding="py-4"
                >
                </vision2-side-by-side>
            </div>
        </div>
    </div>
    } }
</section>
}
